const checkResponse = async (responsePromise) => {
  try {
    const response = await responsePromise;
    return { response, error: null };
  } catch (error) {
    return { response: null, error };
  }
};
export default checkResponse;
